import { SetState } from 'zustand';
import { CommonNotesQueryState, NotSelectedWorklist } from 'stores/interfaces/CommonQueryState';
import { DocumentType, Worklist } from 'generated/graphql';
import { ValueState } from '@ui5/webcomponents-react';

export const commonNotesQueryInitialStateFields = {
  documentNumber: '',
  component: '',
  documentType: '' as DocumentType,
  worklist: null,
  documentResponsible: ''
};

export const commonNotesQueryInitialStateValueStates = {
  documentNumberValueState: ValueState.None,
  componentValueState: ValueState.None,
  documentTypeValueState: ValueState.None,
  worklistValueState: ValueState.None,
  documentResponsibleValueState: ValueState.None
};

export const commonNotesQueryInitialState = {
  ...commonNotesQueryInitialStateFields,
  ...commonNotesQueryInitialStateValueStates,
  fetching: false
};

export const createCommonNotesQuerySlice = <T extends CommonNotesQueryState>(set: SetState<T>) => ({
  ...commonNotesQueryInitialState,
  setDocumentNumber: (value: string) => set(() => ({ documentNumber: value })),
  setComponent: (value: string) => set(() => ({ component: value })),
  setDocumentType: (value: DocumentType) => set(() => ({ documentType: value })),
  setWorklist: (value?: Worklist | NotSelectedWorklist | null) => set(() => ({ worklist: value })),
  setDocumentResponsible: (value: string) => set(() => ({ documentResponsible: value })),
  setDocumentNumberValueState: (value: ValueState) =>
    set(() => ({
      documentNumberValueState: value
    })),
  setComponentValueState: (value: ValueState) =>
    set(() => ({
      componentValueState: value
    })),
  setDocumentTypeValueState: (value: ValueState) =>
    set(() => ({
      documentTypeValueState: value
    })),
  setWorklistValueState: (value: ValueState) =>
    set(() => ({
      worklistValueState: value
    })),
  setDocumentResponsibleValueState: (value: ValueState) =>
    set(() => ({
      documentResponsibleValueState: value
    })),
  setFetching: (value: boolean) => set(() => ({ fetching: value })),
  resetData: () => {
    set({
      documentNumber: '',
      component: '',
      documentType: '' as DocumentType,
      worklist: NotSelectedWorklist.NOT_SELECTED_WORKLIST,
      documentResponsible: '',
      documentNumberValueState: ValueState.None,
      componentValueState: ValueState.None,
      documentTypeValueState: ValueState.None,
      worklistValueState: ValueState.None,
      documentResponsibleValueState: ValueState.None
    });
  }
});
